var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":_vm.colSize}},[_c('v-subheader',{staticClass:"text-left text-xl-h5 text-lg-h5 text-md-h5 text-sm-h6"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }